import React from "react";
import Image from "../assets/image.svg";
import Dashboardd from "../assets/dashboard.svg";
import register from "../assets/patient_register.svg";

import View from "../assets/view.svg";
import Appointment from "../assets/appointment.svg";
import Icon from "../assets/Icon.svg";
import { Link, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { validateToken } from "../tokenValidation";
import secureStorage from "../utils/secureStorage";
import aadhaar from '../assets/aadhaar.svg';

const Dashboard = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const navigate = useNavigate();

  const handleAadhaarClick = () => {
    navigate("/healthacnt");
  };

  const handleLoginClick = () => {
    navigate("/abhalogin");
  };

  useEffect(() => {
    validateToken(navigate);
  }, [navigate]);

  return (
    <div className="bg-gray-50 min-h-screen">
      {/* Welcome Section */}
      {/* Welcome Section */}
      <div className="max-w-7xl mx-auto text-left py-8">
        <h1 className="text-[30px] font-bold text-gray-800">
          Welcome to {secureStorage.get("orgName") || "HealthIdHub"}
        </h1>
        <p className="text-[20px] text-gray-600 mt-2">
          Secure your health journey with our digital platform
        </p>
      </div>

      {/* ABHA Section */}
      <div
        className="rounded-lg text-white flex items-center justify-between p-8 shadow-lg mx-auto max-w-7xl"
        style={{
          background: "linear-gradient(0deg, #429C95 -10.42%, #0F766E 113.96%)",
          height: "235px",
        }}
      >
        <div className="max-w-lg">
          <h2 className="text-[24px] font-bold mb-4">
            Create ABHA for patients.
          </h2>
          <p className="text-[16px] leading-relaxed">
            Secure your health records and access healthcare services
            effortlessly by generating your unique Ayushman Bharat Health
            Account (ABHA) today.
          </p>
          <button
            className="mt-6 mr-4 px-8 py-3 bg-white text-teal-600 font-medium rounded-full hover:bg-gray-100 transition"
            onClick={openModal}
          >
            Create ABHA Account
          </button>
          {/* <button
            className="mt-6 px-8 py-3 bg-white text-teal-600 font-medium rounded-full hover:bg-gray-100 transition"
            onClick={handleLoginClick}
          >
            Create new ABHA Address
          </button> */}
        </div>
        <div>
          <img src={Image} alt="Create ABHA" className="mb-10 w-[19rem]" />
        </div>
      </div>

      <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 max-w-7xl mx-auto px-4 ">
        <Link
          to="/abhalogin"
          className="bg-[#DEEBEC] border border-[#0F766E] rounded-lg p-6 text-center shadow-sm flex flex-col items-center"
        >
          <img
            src={register}
            alt="add-user-male"
            className="h-[8rem] object-contain"
          />
          <h3 className="text-[16px] font-bold text-[#373737] mb-2">
            Start Patient Registration
          </h3>
          <p className="text-gray-600 text-[15px]">
           Check if the patient has an existing ABHA profile. You can link it, create a new one, or register the patient without ABHA.
          </p>
        </Link>

        <Link
          to="/viewappointment"
          className="bg-[#DEEBEC] border border-[#0F766E] rounded-lg p-6 text-center shadow-sm flex flex-col items-center"
        >
          <img src={View} alt="View Icon" className="h-[8rem] object-contain" />
          <h3 className="text-[16px] font-bold text-[#373737] mb-2">
            View Appointment
          </h3>
          <p className="text-gray-600 text-[15px]">
            Access and manage booked appointments. Stay organized and never miss
            an important schedule.
          </p>
        </Link>

        {/* <Link to="/uploadabha" className="bg-[#DEEBEC] border border-[#0F766E] rounded-lg p-6 text-center shadow-sm flex flex-col items-center">
                    <img
                        src={Dashboardd}
                        alt="Appointment Icon"
                        className=" h-[8rem] object-contain"
                    />

                    <h3 className="text-[16px] font-bold text-[#373737] mb-2">Upload ABHA</h3>
                    <p className="text-gray-600 text-[15px]">
                        Quickly upload and link the medical records with ABHA (Ayushman Bharat Health Account) with our platform securely.
                    </p>
                </Link> */}

        <Link
          to="/viewall"
          className="bg-[#DEEBEC] border border-[#0F766E] rounded-lg p-6 text-center shadow-sm flex flex-col items-center"
        >
          <img
            src={Appointment}
            alt="Dashboard Icon"
            className=" h-[8rem] object-contain"
          />

          <h3 className="text-[16px] font-bold text-[#373737] mb-2">
            View All Patients
          </h3>
          <p className="text-gray-600 text-[15px]">
            Browse and manage all customer profiles effortlessly. Keep track of
            customer data in one place.
          </p>
        </Link>
        <Link
          to="/viewdoctor"
          className="bg-[#DEEBEC] border border-[#0F766E] rounded-lg p-6 text-center shadow-sm flex flex-col items-center"
        >
          <img
            src={Icon}
            alt="Dashboard Icon"
            className=" h-[8rem] object-contain"
          />

          <h3 className="text-[16px] font-bold text-[#373737] mb-2">
            Practitioner Details
          </h3>
          <p className="text-gray-600 text-[15px]">
            Effortlessly manage and access comprehensive practitioner profiles
            in one centralized, organized directory.
          </p>
        </Link>
      </div>

      <>
        {isModalOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg p-8 max-w-lg w-full">
              <div className="flex justify-between items-center mb-6">
                <h2 className="text-2xl font-bold text-teal-600">
                  Create ABHA Number
                </h2>
                <button
                  onClick={closeModal}
                  className="text-gray-600 hover:text-gray-900 text-xl font-bold"
                >
                  &times;
                </button>
              </div>
              <p className="text-gray-700 mb-6">
                Please choose the option below to start with the creation of
                your ABHA.
              </p>

              <div
                className="flex flex-col items-center justify-center border-2 border-gray-300 rounded-lg p-4 shadow-md hover:shadow-lg hover:border-teal-600 transition-transform transform hover:scale-105 cursor-pointer"
                onClick={handleAadhaarClick}
              >
                <img
                  src={aadhaar}
                  alt="Aadhaar"
                  className="w-16 h-16 mb-4"
                />
                <h3 className="text-teal-600 font-semibold">Aadhaar</h3>
              </div>

              {/* <p className="text-center text-gray-600 mt-6 font-semibold">
                                Already have an ABHA number?{" "}
                                <a href="/abhalogin" className="text-teal-600 underline">
                                    Login
                                </a>
                            </p> */}
            </div>
          </div>
        )}
      </>
    </div>
  );
};

export default Dashboard;
